import React from 'react';
import './ModuleTabs.css';

/* Pestañas de módulo (F2, ESTANDAR §2): SOLO para vistas realmente distintas
   dentro del mismo módulo — nunca para categorías/fechas/canales (eso son
   filtros). Badge de conteo opcional (ej. "Gestión de envíos (7)").
   FIRMADO por Miguel (2026-07-22): la variante de toda la app es 'underline'
   (texto + indicador inferior violeta) — separa pestañas (navegación) de
   filtros-pill (selección), el criterio del brief §8. La variante 'chips'
   queda solo como compatibilidad transitoria y se retira en F7. */
export default function ModuleTabs({
  tabs = [],               // [{ id, label, badge? }]
  active,
  onChange,
  variant = 'underline',
  ariaLabel = 'Secciones del módulo',
  className = '',
}) {
  return (
    <div className={`ui-tabs ui-tabs--${variant}${className ? ` ${className}` : ''}`} role="tablist" aria-label={ariaLabel}>
      {tabs.map((t) => {
        const isActive = active === t.id;
        return (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`ui-tab${isActive ? ' is-active' : ''}`}
            onClick={() => onChange?.(t.id)}
          >
            <span className="ui-tab-label">{t.label}</span>
            {t.badge != null && t.badge !== 0 && (
              <span className="ui-tab-badge">{t.badge > 99 ? '99+' : t.badge}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
